export const formatDate = (tickItem, isWeekly) => {
    const date = new Date(tickItem); 
    const month = date.getMonth()+1;
    const day = String(date.getDate());
    const year = date.getFullYear();
    const monthName =  date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
    
    if (isWeekly === '+7DAY') {
      
      return `${monthName} ${day}, ${year}`;
    } else if (isWeekly === '+1MONTH') {
      return `${monthName}, ${year}`;
    } else if (isWeekly === '+3MONTH') {
      let quarter;
    
      if (month >= 1 && month <= 3) {
        quarter = 'Q1';
      } else if (month >= 4 && month <= 6) {
        quarter = 'Q2';
      } else if (month >= 7 && month <= 9) {
        quarter = 'Q3';
      } else {
        quarter = 'Q4';
      }
      return `${quarter} ${year}`;
    } else if (isWeekly === '+1YEAR') {
      return `${year}`;
    }
    else{
      return `${month.toString().padStart(2, '0')}/${day}/${year}`;
    }
  }
  
  export const getPreviousMonthsData = (cardListViewData) => {
    if (
      !cardListViewData ||
      cardListViewData.length <= 0 ||
      !cardListViewData[cardListViewData.length - 1]
    )
      return [];
    return [
      cardListViewData[cardListViewData.length - 2],
      cardListViewData[cardListViewData.length - 1],
    ];
  };

  export const getPreviousYearData = (cardListViewData, currentDate, isWeekly) => {
    if (!cardListViewData) return [];
  
    const inputDate = new Date(currentDate);
    let targetDate;
  
    const getUTCDateString = (date) => {
      return date instanceof Date && !isNaN(date)
        ? date.toISOString().split("T")[0]
        : null;
    };
  
    switch (isWeekly) {
      case "+7DAY": {
        targetDate = new Date(Date.UTC(
          inputDate.getUTCFullYear(),
          inputDate.getUTCMonth(),
          inputDate.getUTCDate() - 52 * 7
        ));
        break;
      }
  
      case "+1MONTH": {
        const year = inputDate.getUTCFullYear() - 1;
        const month = inputDate.getUTCMonth();
        const day = inputDate.getUTCDate();
        targetDate = new Date(Date.UTC(year, month, day));
  
        // If day rolled over (e.g., Feb 29 → Mar 1), correct to end of previous month
        if (targetDate.getUTCMonth() !== month) {
          targetDate = new Date(Date.UTC(year, month + 1, 0));
        }
        break;
      }
  
      case "+3MONTH": {
        const year = inputDate.getUTCFullYear() - 1;
        const quarterStartMonth = Math.floor(inputDate.getUTCMonth() / 3) * 3;
        targetDate = new Date(Date.UTC(year, quarterStartMonth, 1));
        break;
      }
  
      default: {
        const year = inputDate.getUTCFullYear() - 1;
        const month = inputDate.getUTCMonth();
        const day = inputDate.getUTCDate();
        targetDate = new Date(Date.UTC(year, month, day));
  
        if (targetDate.getUTCMonth() !== month) {
          targetDate = new Date(Date.UTC(year, month + 1, 0));
        }
      }
    }
  
    const targetDateStr = getUTCDateString(targetDate);
  
    if (!targetDateStr) return null;
  
    return cardListViewData.find((item) => {
      const itemDateStr = getUTCDateString(new Date(item.val));
      return itemDateStr === targetDateStr;
    });
  };





  export const getValueFromDotSeparatedKey = (jsonObject, keyString) => {
    if (!jsonObject || !keyString) return undefined;
    const keys = keyString.split(".");

    const getValue = (obj, keys) => {
      if (keys.length === 0) return obj;
      const [firstKey, ...restKeys] = keys;
      if (obj.hasOwnProperty(firstKey)) {
        return getValue(obj[firstKey], restKeys);
      } else {
        return undefined;
      }
    };

    return getValue(jsonObject, keys);
  };
  export const _sliceToLastNonZero = (arr, type) => {
    let lastIndex = arr.length - 1;
    while (lastIndex >= 0 && (!arr[lastIndex][type.key] || arr[lastIndex][type.key].count === 0)) {
    lastIndex--;
    }
    return arr.slice(0, lastIndex + 1);
  };
  export const getPercentage = (val1, val2) => {
    if (val1 && val2) {
    const percentageChange = ((val1 - val2) / val2) * 100;
    return `${percentageChange > 0 ? "+" : ""}${percentageChange.toFixed(2)}%`;
    } else {
    return "";
    }
  };





    export const neighbourhoodsGeoJSON = [
      {
          "fontSize": 24,
          "location": "Hudson Yards",
          "geocode": "40.757066542278565, -73.9993304014206"
      },
      {
          "fontSize": 24,
          "location": "West Chelsea",
          "geocode": "40.74829288975582, -74.00521516799927"
      },
      {
          "fontSize": 24,
          "location": "Roosevelt Island",
          "geocode": "40.76147044864685, -73.95067512989044"
      },
      {
          "fontSize": 24,
          "location": "Turtle Bay",
          "geocode": "40.75301527256151, -73.96992266178131"
      },
      {
          "fontSize": 24,
          "location": "Midtown South",
          "geocode": "40.74991453334029, -73.98729264736176"
      },
      {
          "fontSize": 24,
          "location": "Midtown",
          "geocode": "40.75957350129747, -73.97752940654755"
      },
      {
          "fontSize": 24,
          "location": "Murray Hill",
          "geocode": "40.7478338717919, -73.97498667240143"
      },
      {
          "fontSize": 24,
          "location": "Chelsea",
          "geocode": "40.74443200356971, -73.99752795696259"
      },
      {
          "fontSize": 24,
          "location": "Nomad",
          "geocode": "40.74338774888568, -73.98717999458313"
      },
      {
          "fontSize": 24,
          "location": "Long Island City",
          "geocode": "40.75456728560614, -73.9390879869461"
      },
      {
          "fontSize": 24,
          "location": "Hunter's Point",
          "geocode": "40.74370866814324, -73.95182847976685"
      },
      {
          "fontSize": 24,
          "location": "Soho",
          "geocode": "40.72396964010488, -74.00536000728607"
      },
      {
          "fontSize": 24,
          "location": "Tribeca",
          "geocode": "40.71963558266516, -74.00881469249725"
      },
      {
          "fontSize": 24,
          "location": "West Village",
          "geocode": "40.73612004706007, -74.00723218917847"
      },
      {
          "fontSize": 24,
          "location": "Greenpoint",
          "geocode": "40.72823351537336, -73.9434814453125"
      },
      {
          "fontSize": 24,
          "location": "Stuyvesant Town",
          "geocode": "40.73072216147551, -73.97674083709717"
      },
      {
          "fontSize": 24,
          "location": "Greenwich Village",
          "geocode": "40.73196587483879, -73.99680376052856"
      },
      {
          "fontSize": 24,
          "location": "Kips Bay",
          "geocode": "40.74048156125568, -73.9780068397522"
      },
      {
          "fontSize": 24,
          "location": "Gramercy Park",
          "geocode": "40.73578297634862, -73.98426711559296"
      },
      {
          "fontSize": 24,
          "location": "Williamsburg",
          "geocode": "40.71939166137594, -73.95921528339386"
      },
      {
          "fontSize": 24,
          "location": "Lower East Side",
          "geocode": "40.71850133349672, -73.98427248001099"
      },
      {
          "fontSize": 24,
          "location": "East Village",
          "geocode": "40.72657122058716, -73.98182094097137"
      },
      {
          "fontSize": 24,
          "location": "Flatiron",
          "geocode": "40.73895341181816, -73.99162173271179"
      },
      {
          "fontSize": 24,
          "location": "Lenox Hill",
          "geocode": "40.76518072692423, -73.96174728870392"
      },
      {
          "fontSize": 24,
          "location": "Astoria",
          "geocode": "40.76594775260746, -73.92340779304504"
      },
      {
          "fontSize": 24,
          "location": "Sunnyside",
          "geocode": "40.74416749275569, -73.92411589622498"
      },
      {
          "fontSize": 24,
          "location": "Jackson Heights",
          "geocode": "40.75623313421981, -73.88520240783691"
      },
      {
          "fontSize": 24,
          "location": "Woodside",
          "geocode": "40.75381464480567, -73.90441238880157"
      },
      {
          "fontSize": 24,
          "location": "Elmhurst",
          "geocode": "40.741692624278755, -73.88349652290344"
      },
      {
          "fontSize": 24,
          "location": "Laurel Hill",
          "geocode": "40.72932769361063, -73.92303228378296"
      },
      {
          "fontSize": 24,
          "location": "Blissville",
          "geocode": "40.73355127752929, -73.93463015556335"
      },
      {
          "fontSize": 24,
          "location": "Maspeth",
          "geocode": "40.727379153965714, -73.90506148338318"
      },
      {
          "fontSize": 24,
          "location": "Upper East Side",
          "geocode": "40.77735387339487, -73.95708560943604"
      },
      {
          "fontSize": 24,
          "location": "Upper Manhattan",
          "geocode": "40.81712958416742, -73.94792318344116"
      },
      {
          "fontSize": 24,
          "location": "Williamsburg and Greenpoint",
          "geocode": "40.71886436667593, -73.94811630249023"
      },
      {
          "fontSize": 24,
          "location": "Northeast Brooklyn",
          "geocode": "40.69161504040213, -73.93039226531982"
      },
      {
          "fontSize": 24,
          "location": "Southeast Brooklyn",
          "geocode": "40.65741977033356, -73.89357089996338"
      },
      {
          "fontSize": 24,
          "location": "Flushing Meadows Corona Park",
          "geocode": "40.73455662723063, -73.8335756111145"
      },
      {
          "fontSize": 24,
          "location": "Whitestone",
          "geocode": "40.78517009331627, -73.81445646286011"
      },
      {
          "fontSize": 24,
          "location": "College Point",
          "geocode": "40.78187166360195, -73.84192228317261"
      },
      {
          "fontSize": 24,
          "location": "East Elmhurst",
          "geocode": "40.771407755386775, -73.87256383895874"
      },
      {
          "fontSize": 24,
          "location": "Forest Hills",
          "geocode": "40.724004763964786, -73.84602069854736"
      },
      {
          "fontSize": 24,
          "location": "Middle Village",
          "geocode": "40.72546862960313, -73.87546062469482"
      },
      {
          "fontSize": 24,
          "location": "Hollis",
          "geocode": "40.7087336082316, -73.76521110534668"
      },
      {
          "fontSize": 24,
          "location": "Fresh Meadows",
          "geocode": "40.7356638930863, -73.78096103668213"
      },
      {
          "fontSize": 24,
          "location": "Douglaston-Little Neck",
          "geocode": "40.76358955538106, -73.73502016067505"
      },
      {
          "fontSize": 24,
          "location": "Queens Village",
          "geocode": "40.72271840267422, -73.7407922744751"
      },
      {
          "fontSize": 24,
          "location": "Bayside",
          "geocode": "40.76962375278711, -73.7874698638916"
      },
      {
          "fontSize": 24,
          "location": "Bay Terrace",
          "geocode": "40.762680646322005, -73.79044914245605"
      },
      {
          "fontSize": 24,
          "location": "Bulls Head",
          "geocode": "40.60702387579481, -74.16584193706512"
      },
      {
          "fontSize": 24,
          "location": "Meiers Corner",
          "geocode": "40.612722450187945, -74.14129972457886"
      },
      {
          "fontSize": 24,
          "location": "Mariners Harbor",
          "geocode": "40.63426896595929, -74.15427088737488"
      },
      {
          "fontSize": 24,
          "location": "Elm Park",
          "geocode": "40.63110224890063, -74.14771556854248"
      },
      {
          "fontSize": 24,
          "location": "Westerleigh",
          "geocode": "40.61946968315654, -74.14142847061157"
      },
      {
          "fontSize": 24,
          "location": "Graniteville",
          "geocode": "40.61969355284781, -74.15752172470093"
      },
      {
          "fontSize": 24,
          "location": "Bloomfield",
          "geocode": "40.61349493064394, -74.17438745498657"
      },
      {
          "fontSize": 24,
          "location": "Willowbrook",
          "geocode": "40.60071485762391, -74.14416432380676"
      },
      {
          "fontSize": 24,
          "location": "Port Richmond",
          "geocode": "40.63425258278755, -74.13098931312561"
      },
      {
          "fontSize": 12,
          "location": "Lincoln Square",
          "geocode": "40.77449241842551, -73.98602664470673"
      },
      {
          "fontSize": 12,
          "location": "Clinton",
          "geocode": "40.76595260087812, -73.99304866790771"
      },
      {
          "fontSize": 24,
          "location": "Old Place",
          "geocode": "40.627348341824046, -74.17367935180664"
      },
      {
          "fontSize": 12,
          "location": "Sutton Place",
          "geocode": "40.75739594898354, -73.96248757839203"
      },
      {
          "fontSize": 24,
          "location": "Arlington",
          "geocode": "40.63835624057748, -74.17347550392151"
      },
      {
          "fontSize": 24,
          "location": "West New Brighton",
          "geocode": "40.633828435910644, -74.10898447036743"
      },
      {
          "fontSize": 24,
          "location": "Randall Manor",
          "geocode": "40.63933720197032, -74.10086274147034"
      },
      {
          "fontSize": 24,
          "location": "Silver Lake",
          "geocode": "40.62464874219435, -74.09892082214355"
      },
      {
          "fontSize": 24,
          "location": "Sunnyside",
          "geocode": "40.613406696759, -74.10732686519623"
      },
      {
          "fontSize": 24,
          "location": "Castleton Corners",
          "geocode": "40.618614144439746, -74.11779820919037"
      },
      {
          "fontSize": 24,
          "location": "Manor Heights",
          "geocode": "40.6016242606115, -74.12276029586792"
      },
      {
          "fontSize": 24,
          "location": "Todt Hill",
          "geocode": "40.59564358078593, -74.10588383674622"
      },
  
  
          {
              "fontSize": 12,
              "location": "Fordham Heights",
              "geocode": "40.8559869155434, -73.89934301376343"
          },
          {
              "fontSize": 12,
              "location": "Pelham Gardens",
              "geocode": "40.86408492461834, -73.84179353713989"
          },
          {
              "fontSize": 12,
              "location": "Mount Hope",
              "geocode": "40.84938943621037, -73.90708923339844"
          },
          {
              "fontSize": 12,
              "location": "Allerton",
              "geocode": "40.867524780627974, -73.85786533355713"
          },
          {
              "fontSize": 12,
              "location": "Fordham University",
              "geocode": "40.86242993854577, -73.88596415519714"
          },
          {
              "fontSize": 12,
              "location": "Fordham North",
              "geocode": "40.866543625789475, -73.8934850692749"
          },
          {
              "fontSize": 12,
              "location": "Eastchester",
              "geocode": "40.88382282879941, -73.82985234260559"
          },
          {
              "fontSize": 12,
              "location": "Olinville",
              "geocode": "40.879158687219345, -73.86609435081482"
          },
          {
              "fontSize": 12,
              "location": "Morris Park",
              "geocode": "40.85153986526066, -73.85129928588867"
          },
          {
              "fontSize": 12,
              "location": "Williamsbridge",
              "geocode": "40.8794833276005, -73.85505437850952"
          },
          {
              "fontSize": 12,
              "location": "Kingsbridge Heights",
              "geocode": "40.87409600462664, -73.8970148563385"
          },
          {
              "fontSize": 12,
              "location": "Bronx Zoo",
              "geocode": "40.86174641259002, -73.87614727020264"
          },
          {
              "fontSize": 12,
              "location": "Norwood",
              "geocode": "40.8777713110658, -73.87739181518555"
          },
          {
              "fontSize": 12,
              "location": "Bedford Park",
              "geocode": "40.872839240001994, -73.88671517372131"
          },
          {
              "fontSize": 12,
              "location": "Edenwald",
              "geocode": "40.88661320456035, -73.84080648422241"
          },
          {
              "fontSize": 12,
              "location": "Co-op City",
              "geocode": "40.8695773671848, -73.82675170898438"
          },
          {
              "fontSize": 12,
              "location": "Bronxdale",
              "geocode": "40.86412551484514, -73.86372327804565"
          },
          {
              "fontSize": 12,
              "location": "Tremont",
              "geocode": "40.850614792138686, -73.89360308647156"
          },
          {
              "fontSize": 12,
              "location": "Belmont",
              "geocode": "40.85638467177354, -73.88813138008118"
          },
          {
              "fontSize": 12,
              "location": "West Farms",
              "geocode": "40.848375034426894, -73.88513803482056"
          },
          {
              "fontSize": 12,
              "location": "Van Nest",
              "geocode": "40.84853734079964, -73.86504292488098"
          },
          {
              "fontSize": 12,
              "location": "Pelham Bay",
              "geocode": "40.850825776002225, -73.83137583732605"
          },
          {
              "fontSize": 12,
              "location": "Van Cortland Park",
              "geocode": "40.894778870892196, -73.88052463531494"
          },
          {
              "fontSize": 12,
              "location": "Pelham Bay Park",
              "geocode": "40.867676077177194, -73.80931735038757"
          },
          {
              "fontSize": 12,
              "location": "Baychester",
              "geocode": "40.87063235220354, -73.84160041809082"
          }
      
  ];
  
  export const boroughsGeoJSON=[
      {
          "location": "Bronx",
          "geocode": "40.837048, -73.865433",
          "fontSize": 24,
          "offset": [
              0,
              -1.5
          ]
      },
      {
          "location": "Manhattan",
          "geocode": "40.754932, -73.984016",
          "fontSize": 24,
          "offset": [
              0,
              -1.5
          ]
      },
      {
          "location": "Brooklyn",
          "geocode": "40.650002, -73.949997",
          "fontSize": 24,
          "offset": [
              0,
              -1.5
          ]
      },
      {
          "location": "Queens",
          "geocode": "40.742054, -73.769417",
          "fontSize": 24,
          "offset": [
              -3,
              3
          ]
      },
      {
          "location": "Staten Island",
          "geocode": "40.579021, -74.151535",
          "fontSize": 24,
          "offset": [
              0,
              -1.5
          ]
      }
  ]